import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CookieUtils} from '../../utils/CookieUtils';
import {GeneralConstant} from '../../constants/GeneralConstant';

@Component({
  selector: 'app-logout',
  template: ''
})
export class LogoutComponent implements OnInit {


  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    CookieUtils.removeCookie(GeneralConstant.TOKEN);
    CookieUtils.removeCookie(GeneralConstant.REFRESH_TOKEN);
    localStorage.clear();
    const redirectTo = this.activatedRoute.snapshot.queryParams.redirectTo || '/';
    this.router.navigate(['login'], {queryParams: {redirectTo}});
  }
}
